<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">
            <div class="bg-light lter b-b wrapper-md">
              <div class="row">
                <div class="col-sm-6 col-xs-12">
                  <h1 class="font-thin h3">Cobranças</h1>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="wrapper clearfix" style="display: flex; flex-direction: row; width: 100%;"> 
                <div class="col-sm-9 m-b-xs">
                  <label>Importar arquivo de Retorno BRADESCO
                    <input class="btn" type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
                  </label>
                  <button class="btn-default" v-on:click="submitFile()">Submit</button>
                </div>
              
                <div style="display: flex; flex-direction: row;height: min-content;">
                  <button class="btn btn-sm btn-default pull-none-xs m-r-sm hidden-print" ref="btedit" @click="liberarBoletos" >Liberar Boletos</button>
                  <div class="input-group" style="width: 300px;">
                    <input type="text" class="input-sm form-control" placeholder="Pesquisar" v-model="filtros.busca" @keyup="pesquisar">
                    <span class="input-group-btn">
                      <button class="btn btn-sm btn-default" type="button">Buscar</button>
                    </span>
                  </div>
                </div>                  
                
              </div>
              
              <!--  - - - - - TABELA DE BOLETOS - - - - - -->
              <div class="table-responsive">
                <table class="table table-hover table-striped b-t b-light">
                  <thead>
                    <tr>
                      <th style="width:20px;">
                        <label class="i-checks m-b-none">
                          <input type="checkbox" @change="checkAll(boletos)" v-model="checkedAll" tabindex="0"
                                 aria-checked="false"
                                 aria-invalid="false"><i></i>
                        </label>
                      </th>
                      <th style="text-align:center">Id</th>
                      <th style="text-align:center">Numero do Titulo</th>
                      <th style="text-align:left">Sacado</th>
                      <th style="text-align:left">Valor</th>
                      <th style="text-align:center">Data Vencimento</th>
                      <th style="text-align:center">Status Boleto</th>
                      <th style="text-align:center">Status Remessa</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- FAKE -->
                    <tr v-if="isLoading" v-for="i in [1,2,3]">
                      <td class="v-middle">
                        <u-fake-loader width="20px" class="m-t"></u-fake-loader>
                      </td>
                      <td role="button" tabindex="0">
                        <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                      </td>
                      <td role="button" tabindex="0">
                        <a class="text-cap custom-link ">
                          <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                        </a>
                      </td>
                      <td role="button" tabindex="0">
                        <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                      </td>
                      <td role="button" tabindex="0">
                        <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                      </td>
                      <td role="button" tabindex="0">
                        <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                      </td>
                      <td role="button" tabindex="0">
                        <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                      </td>
                      <td role="button" tabindex="0">
                        <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                      </td>
                    </tr>
                    <!-- END FAKE -->

                    <!-- LISTA BOLETOS -->
                    <tr v-for="(boleto) in boletos" v-if="!isLoading">
                      <td class="v-middle">
                        <label class="i-checks m-b-none">
                          <input @change="lazyCheck(boleto)" type="checkbox" name="post[]" tabindex="0" aria-checked="false"
                           aria-invalid="false" v-model="boleto.selected">
                           <i></i>
                        </label>
                      </td>
                      <td role="button" tabindex="0" align="center" @click="open(boleto.id)">
                        {{ boleto.id }}
                      </td>
                      <td role="button" tabindex="0" align="center" @click="open(boleto.id)">
                        {{ 90000000000 + boleto.sequencialNossoNumero }}
                      </td>
                      <td role="button" tabindex="0" align="left" @click="open(boleto.id)">
                        {{ boleto.nomePagador }}
                      </td>
                      <td role="button" tabindex="0" align="left" @click="open(boleto.id)">
                        R$ {{ boleto.valor }}
                      </td>
                      <td role="button" tabindex="0" align="center" @click="open(boleto.id)">
                        {{ moment(boleto.dataVencimento.date).format('DD/MM/YYYY') }}
                      </td>
                      <td role="button" tabindex="0" align="center" @click="open(boleto.id)">
                        {{ boleto.statusBoleto }}
                      </td>
                      <td role="button" tabindex="0" align="center" @click="open(boleto.id)">
                        {{ boleto.status }}
                      </td>
                      
                    </tr>

                    <!-- END LISTA BOLETOS -->
                    <tr v-if="noBoletos">
                      <td colspan="6">Nenhum registro encontrado</td>
                    </tr>
                  </tbody>
                </table>
                <footer class="panel-footer">
                  <div class="row">
                    <div class="col-sm-4 hidden-xs">
                      Mostrar:
                      <select @change="changePage(1)" v-model="pagination.limit"
                              class="input-sm form-control w-auto inline v-middle">
                        <option v-for="p in paginationLimits" :value="p">{{ p }}</option>
                      </select>
                      por página
                    </div>
                    <div class="col-sm-4 text-center">
                      <small class="text-muted inline m-t-sm m-b-sm ">{{ pagination.atualPage }} / {{
                        pagination.totalPages
                        }}
                      </small>
                    </div>
                    <div class="col-sm-4 text-right text-center-xs">
                      <u-pagination @changePage="changePage" :atual="pagination.atualPage"
                                    :total="pagination.totalPages"></u-pagination>
                    </div>
                  </div>
                </footer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
   
</template>

<script>

  import service from '../../../../domain/cobranca/services'
  import UPagination from '../../../_default/components/Uloc/Pagination'
  import { forEach as _forEach, debounce } from 'lodash'

  export default {
    components: {
      UPagination
    },
    name: 'Cobranca',
    data () {
      return {
        file: '',
        boletos: null,
        isLoading: false,
        paginationLimits: [25, 50, 100],
        pagination: {
          totalPages: 0,
          totalItems: 0,
          atualPage: 1,
          limit: 25
        },
        filtros: {
          busca: ''
        },
        checkeds: 0,
        checkedAll: false,
        prevent: {},
        last: null
      }
    },
    computed: {
      noBoletos () {
        if (this.boletos === null) {
          return true
        }
        if (this.boletos.length > 0) {
          return false
        }
        return true
      }
    },
    created () {
      this.carregaBoletos(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
    },
    mounted () {
    },
    methods: {
      carregaBoletos (limit, page, filtros) {
        this.boletos = null
        this.isLoading = true
        service.lista(limit, page, filtros)
          .then((response) => {
            this.isLoading = false
            this.boletos = response.data.boletos
            this.pagination.atualPage = response.data.offset
            this.pagination.totalPages = response.data.totalPages
            this.pagination.totalItems = response.data.total
          })
          .catch((response) => {
            this.isLoading = false
            console.log(response)
          })
      },
  
      handleFileUpload () {
        this.file = this.$refs.file.files[0]
      },
      submitFile () {
        if (this.file.length === 0) {
          window.alert('Você deve selecionar um arquivo para importar!')
        } else {
          let formData = new FormData()
          formData.append('file', this.file)
          service.importRet(formData).then((response) => {
            console.log(response)
            window.alert('Arquivo Importado')
            this.file = ''
            this.$refs.file.value = ''
          }).catch((error) => {
            console.log(error)
            if (error.status === 404) { window.alert('Falha ao fazer o upload do arquivo, endpoint não existe') }
            window.alert(error)
            this.file = ''
            this.$refs.file.value = ''
          })
        }
      },
      changePage (page) {
        console.log('Change page ', page)
        this.pagination.atualPage = page
        this.carregaBoletos(this.pagination.limit, page, this.montaFiltros())
      },
  
      montaFiltros () {
        let filtros = this.filtros
        let mount = ''
        // Busca
        if (filtros.busca.length > 0) {
          mount += '&busca=' + filtros.busca
        }
        return mount
      },
  
      lazyCheck: function (l) {
        this.$nextTick(() => {
          if (l.selected === true) {
            this.checkeds += 1
          } else {
            this.checkeds += -1
          }
  
          if (this.checkeds < this.boletos.length) {
            this.checkedAll = false
          } else {
            this.checkedAll = true
          }
        })
      },
  
      checkAll (o) {
        this.$nextTick(() => {
          let ca = this.checkedAll
          let _vm = this
          if (ca === true) {
            this.checkeds = o.length
          } else {
            this.checkeds = 0
          }
          _forEach(o, (item, key) => {
            _vm.$set(this.boletos, key, Object.assign({}, this.boletos[key], {selected: ca})) // Analisar desempenho
            // item.selected = ca
            // console.log(item)
          })
        })
      },

      pesquisar: debounce(function () { // debounce para evitar fazer mais de uma requisição no key event
        let busca = this.filtros.busca
        if (this.prevent.busca === busca) {
          return
        } // previne a repetição de uma chamada de api
        this.prevent.busca = busca
        this.carregaBoletos(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
      }, 500),

      open (id) {
        this.$router.push({name: 'boletos', params: { id: id }})
      },

      liberarBoletos () {
        let err = false
        if (this.checkeds === 0) {
          window.alert('Nenhum registro selecionado para liberação!')
        } else {
          if (window.confirm('Tem certeza que deseja liberar os boletos selecionados?')) {
            this.isLoading = true
            _forEach(this.boletos, (propriedade, key) => {
              if (propriedade.selected === true) {
                service.liberarBoleto(this.boletos[key].id).then((response) => {
                  if (key + 1 === this.checkeds) {
                    this.checkedAll = false
                    this.carregaBoletos(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
                    if (err !== true) {
                      window.alert('Os boletos foram liberados com sucesso!')
                    } else {
                      window.alert('Ocorreu erro na liberação dos boletos!')
                    }
                  }
                }).catch((error) => {
                  err = true
                  console.log(error)
                })
              }
            })
          }
        }
      }
  
    }
  }
</script>



// WEBPACK FOOTER //
// Cobranca.vue?38960a2e